export default function SavingNotice({ title = "Saving", message = "Saving changes..." }) {
  return (
    <div className="saving-notice-backdrop" aria-live="polite" aria-busy="true">
      <div className="card modal-card workspace-toast-prominent" style={{ maxWidth: 420, width: "calc(100% - 32px)" }}>
        <div className="eyebrow-label workspace-toast-title" style={{ color: "var(--rose)" }}>
          {title}
        </div>
        <div className="workspace-toast-message" style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span className="spinner saving-notice-spinner" />
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}
